import React, { FC } from 'react';
import { TFooterLink } from '../../../../types/footerLink.types';
import { FooterLinkModel } from '../../../../models/footerLink.model';
import RoutableSitecoreLink from '../../../@shared/routableSitecoreLink';
import { googleNavClickEvent } from '../../../../utils/analytics';
import { footerMenu } from '../../../../constants/analytics.constants';
import './styles.scss';

const Navigation: FC<TFooterLink> = (props) => {
  const model = new FooterLinkModel(props);
  const items = model?.list?.map((item: TFooterLink) => {
    const buttonText = item?.fields?.link?.value?.text || item?.fields?.link?.value?.href;
    return (
      <li
        key={buttonText}
        className="footer-navigation__item"
        onMouseUp={() => googleNavClickEvent(footerMenu, item?.fields?.link?.value?.href, item?.fields?.link?.value?.title)}
      >
        {item?.fields?.isModalPopup?.value ? (
          // external consent cookie notice button
          <button id="ot-sdk-btn" className="ot-sdk-show-settings footer-navigation__cookieBtn">
            {buttonText}
          </button>
        ) : (
          <RoutableSitecoreLink field={item?.fields?.link} className="footer-navigation__link" />
        )}
      </li>
    );
  });
  return <ul className="footer-navigation">{items}</ul>;
};

export default Navigation;
